export default __webpack_public_path__ + "static/media/intro-promo-v2.b99c155d.svg";